import React from 'react';
import i18n from '@i18n';
import PropTypes from 'prop-types';
import { TicketFooterRow } from '../TicketFooter';
import { formatMoney } from '@/common/client';

function OddsAdvantageNg({ points, multiplier }) {
    return (
        <TicketFooterRow
            rowInfo={`${multiplier} (${i18n('jsp.detailTiketu.pouzitych')} ${formatMoney(points, 'NIK', 0)})`}
            rowTitle="ticketus.extras.oddsAdvantage"
        />
    );
}

OddsAdvantageNg.propTypes = {
    points: PropTypes.number.isRequired,
    multiplier: PropTypes.number.isRequired
};

export default OddsAdvantageNg;
